export { default as logo } from "./logo/logo.jpg"